const page = {
  state: {
    tabIndex: 0
  },
  mutations: {
    SET_INDEX (state, index) {
      state.tabIndex = index
    },
    CLEAR_INDEX (state, index) {
      state.tabIndex = 0
    }
  },
  actions: {

  }
}
export default page
